// extracted by mini-css-extract-plugin
export default {"wrapper":"Gn-z","response":"Hn-z","error":"In-z","disabled":"Jn-z","buttons":"Kn-z","feedbackQuestionSection":"Ln-z","yesNoWrapper":"Mn-z"};